import styled from "styled-components";

export const MonsterPointWrapper = styled.div`
  /* border: 1px solid black; */
`;

export const ContentContainer = styled.div`
  display: flex;
  padding: 2rem;

  /* border: 1px solid black; */
`;

export const MonsterPointGridContainer = styled.div`
  /* border: 1px solid black; */
  display: grid;
  grid-template-areas:
    "RecentPointsTitle   ThisMonthUsedFeeTitle"
    "RecentPoints ThisMonthUsedFee"
  
    ;
  // grid-template-rows: 40px 40px;
  width: 100%;
  font-size : 14px;
`;

export const RecentPointsTitle = styled.div`
  grid-area: RecentPointsTitle;
  text-align: left;
  /* border: 1px solid black; */
  font-size: 14px;
  
`;
export const RecentPoints = styled.div`
  grid-area: RecentPoints;
  text-align: left;
  /* border: 1px solid black; */
  color: rgb(139, 197, 65);
  padding-right: 30px;
`;
export const ThisMonthUsedFeeTitle = styled.div`
  grid-area: ThisMonthUsedFeeTitle;
  text-align: center;
  /* border: 1px solid black; */
  // padding-top: 15px;
  font-size: 14px;
`;
export const ThisMonthUsedFee = styled.div`
  grid-area: ThisMonthUsedFee;
  text-align: center;
  /* border: 1px solid black; */
  color: rgb(139, 197, 65);
  padding-right: 30px;
  font-size : 14px;
  // padding-top: 15px;
  position : relative;
  left : -3px;
`;
export const AvailablePointsContainer = styled.div`
  /* border: 1px solid black; */
  display: flex;
  flex-direction: column;
  font-size: 20px;
`;
export const AvailablePointsTitle = styled.div`
  /* border: 1px solid black; */
  font-weight: bold;
  color: rgb(139, 197, 65);
  padding: 10px;
`;
export const AvailablePoints = styled.div`
  /* border: 1px solid black; */
  font-weight: bold;
  color: rgb(139, 197, 65);
  padding: 10px;
`;
export const MoneyImage = styled.img`
  /* border: 1px solid black; */
`;
export const EventContainer = styled.div`
  border-top : 2px solid #eee;
  border-bottom : 2px solid #eee;
  padding : 2rem 0;
  display : flex;
  flex-direction: column;
  margin :0 0 5rem 0 ;
  @media screen and (max-width : 520px){
    margin : 0;
   }
`
export const EventWrap = styled.div`
 display : flex;
 align-items: center;
 margin : 1rem 0 ;
 padding-left : 2rem;
 @media screen and (max-width : 520px){
  /* flex-direction: column; */
  
  margin : 1rem 0 1rem 0;
  justify-content: center;
 }
 @media screen and (max-width : 320px){
  padding : 0;
 }
`
export const EventCircle = styled.div`
  width : 50px;
  height : 50px;
  border-radius: 100%;
  background : ${props => props.primary ? "#8ac541" : "#6fcccc"};
  margin-right : 1rem;
  @media screen and (max-width : 520px){
    margin : .5rem 0;
   }
`
export const EventCircleText = styled.p`
  padding : 1rem 0; 
  color : #ffffff;
  @media screen and (max-width : 520px){
    margin : 0;
   }
`
export const EventTextContainer = styled.div`
  display : flex;
  flex-direction: column;
  margin-right : 5rem;
  flex : 1;
  @media screen and (max-width : 520px){
    margin : 0.5rem 0 0.5rem 0.5rem;
    align-items : flex-start;
    width : 152px;
   }
`
export const DownloadButton = styled.div`
  margin : .5rem 0;
  cursor : pointer;
`
export const DownloadButtonText = styled.p`
  flex : 1;
  padding : .4rem;
  color : ${props => props.click ? "#fff" :"#8ac541" };
  background : ${props => props.click ? "#8ac541" :"#fff" };
  border :1px solid ${props => props.click ? "#fff" :"#8ac541" };
  border-radius: 5px;
  display: flex;
  align-items : center;
  justify-content : center;
  font-size : 14px;
  img{
    width : 15px; 
    height: 20px;
    padding-right : 5px;
  }
  @media screen and (max-width : 320px) {
    width : 55px;
  }
`